'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _config = require('config/config');

var config = _interopRequireWildcard(_config);

var _modal = require('redux/actions/modal');

var _helpers = require('helpers');

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    BuyInCreditModal: {
        displayName: 'BuyInCreditModal'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Basket/BuyInCreditModal/BuyInCreditModal.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var BuyInCreditModal = _wrapComponent('BuyInCreditModal')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        lang: state.lang,
        currency: state.currency,
        user: state.auth.user
    };
}, { hide: _modal.hide }), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(BuyInCreditModal, _Component);

    function BuyInCreditModal(props, context) {
        (0, _classCallCheck3.default)(this, BuyInCreditModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BuyInCreditModal.__proto__ || (0, _getPrototypeOf2.default)(BuyInCreditModal)).call(this, props, context));

        _this.closeModal = function () {
            _this.props.hide();
        };

        _LocalStorageProxy2.default.removeItem('buy_in_credit');
        _this.state = {
            changeQuantity: 10,
            changeChildMods: 10
        };
        return _this;
    }

    (0, _createClass3.default)(BuyInCreditModal, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('BuyInCreditModal', null, { folderName: "Basket/BuyInCreditModal" });

            return _react3.default.createElement(View, (0, _extends3.default)({}, this.props, {
                closeModal: this.closeModal,
                creditUrl: config.creditUrl
            }));
        }
    }]);
    return BuyInCreditModal;
}(_react2.Component), _class2.propTypes = {
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = BuyInCreditModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Basket/BuyInCreditModal/BuyInCreditModal.jsx
// module id = 1614
// module chunks = 0